import {
    EnvelopeIcon,
    MapPinIcon,
    PhoneIcon,
    ChevronRightIcon,
  } from "@heroicons/react/24/outline";
import { SocialIcon } from "react-social-icons";
  
  const toAbsoluteUrl = (url) => {
    if (!url || typeof url !== "string") return url;
    const trimmed = url.trim();
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return "https://" + trimmed;
  };

  const Other = ({ other, onEvent }) => {
    const getIcon = (item) => {
      switch (item.type) {
        case "email":
          return <EnvelopeIcon className="w-5 h-5" />;
        case "phone":
          return <PhoneIcon className="w-5 h-5" />;
        case "address":
          return <MapPinIcon className="w-5 h-5" />;
        case "link":
          return (
            <SocialIcon
              url={item.url}
              style={{ height: 20, width: 20 }}
            />
          );
        default:
          return null;
      }
    };
  
    const getLinkProps = (type, value, url, location) => {
      switch (type) {
        case "email":
          return { href: `mailto:${value}`, target: "_blank", rel: "noopener noreferrer" };
        case "phone":
          return { href: `tel:${value}`, target: "_blank", rel: "noopener noreferrer" };
        case "address": {
          const latitude = location?.latitude ?? location?.lat;
          const longitude = location?.longitude ?? location?.lng;
          if (
            typeof latitude === "number" &&
            typeof longitude === "number"
          ) {
            const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
            return { href: mapsUrl, target: "_blank", rel: "noopener noreferrer" };
          }
          return null;
        }
        case "link":
          return { href: toAbsoluteUrl(url), target: "_blank", rel: "noopener noreferrer" };
        default:
          return null;
      }
    };
  
    return (
      <div className="p-4 flex flex-col gap-4 rounded-xl bg-slate-50 mt-4 mb-4">
        <div className="w-fit mx-autos ">
          <p className="text-slate-700 font-semibold text-sm mb-4">
            Additional contact information
          </p>
          <div className="flex flex-col gap-4">
          {other.map((other, index) => {
            const linkProps = getLinkProps(
              other.type,
              other.value,
              other.url,
              other.location
            );
            const ContentWrapper = linkProps ? "a" : "div";
  
            const handleClick = () => {
              if (!onEvent || !linkProps) return;

              let target = `other_${other.type}`;
              if (other.type === "link" && other.title) {
                target = `other_link_${other.title.toLowerCase().replace(/\s+/g, "_")}`;
              }

              onEvent({
                action_type: "click",
                target,
              });
            };

            return (
              <ContentWrapper
                key={other.type + index}
                className="flex items-center gap-4"
                onClick={handleClick}
                {...linkProps}
              >
                {getIcon(other)}
                <div className="flex flex-col gap-0">
                  <div className="flex items-center gap-2">
                    <p className="text-slate-700 text-sm">{other.title}</p>
                  </div>
                  {other.type === "link" || other.type === "address" ? (
                    <p className="text-slate-700 text-sm font-semibold" style={{ whiteSpace: 'pre-line' }}>
                      {other.label?.replace(/\\n/g, '\n')}
                    </p>
                  ) : (
                    <p className="text-slate-700 text-sm font-semibold">
                      {other.value}
                    </p>
                  )}
                </div>
                {linkProps && (
                  <ChevronRightIcon className="w-4 h-4 text-slate-400" />
                )}
              </ContentWrapper>
            );
          })}
          </div>
        </div>
      </div>
    );
  };
  
  export { Other };
  